import { QueryKey, useQuery } from "react-query";
import useNetworkHeaders from "../../../../../hooks/useNetworkHeaders";
import getPublicReInspectionPreviousInspections from "../../../api/inspections/public/getPublicReInspectionPreviousInspections";

export default function usePublicReInspectionPreviousInspections({ id }: { id: string | number }) {
  const headers = useNetworkHeaders();
  const key = PublicReInspectionPreviousInspectionsQueryKey(id);
  const query = useQuery(key, getPublicReInspectionPreviousInspections(headers, Number(id)));

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
  };
}

export function PublicReInspectionPreviousInspectionsQueryKey(id: string | number): QueryKey {
  return ["public-previous-inspections", id];
}
